import { Component } from '@angular/core';
import { IonicPage, Nav, NavController, NavParams } from 'ionic-angular';

import { MyAttendance,Employee } from '..';
import { DashboardPage as HomeProject } from '../../project_mobile/index';
import { HomePage as HomeAdvance } from '../../advance_mobile/index';

// @IonicPage()
@Component({
  selector: 'attendance-tabs',
  templateUrl: 'attendance.html'
})
export class AppAttendance {
  tab1Root: any = MyAttendance;
  tab2Root: any = Employee;

  mySelectedIndex :number = 0;

  constructor(public navCtrl: NavController,public nav : Nav,public navParams : NavParams ) {
    this.mySelectedIndex = this.navParams['data']['tabIndex'];
  }
}



// WEBPACK FOOTER //
// ./src/pages/attendance/attendanceApp/attendance.ts